import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Names } from '@ils/static/names.js';
import { DateTime } from 'luxon';

@Entity()
export class CalendarEvent extends MongoEntity {
  static override _class = Names.CalendarEvent._class;
  static override _collectionName = Names.CalendarEvent._collectionName;

  @validate(nonOptional())
  @Field(type => DateTime)
  start!: DateTime;

  @validate(nonOptional())
  @Field(type => DateTime)
  end!: DateTime;

  @Field(type => [String], { default: v => v ?? [] })
  userIDs!: string[];

  override toString() {
    return `${this.start.setLocale('DE-de').toLocaleString(DateTime.DATETIME_MED)} -> ${this.end
      .setLocale('DE-de')
      .toLocaleString(DateTime.DATETIME_MED)}`;
  }
}
